import React from "react";
import { RouteItem } from "./route-item";
import { Link } from "@reach/router";
import {
  Box,
  Icon,
  Flex,
  Text,
  List,
  ListItem,
  ListIcon,
} from "@chakra-ui/react";
import {
  MdAccountCircle,
  MdLocationOn,
  MdPhone,
  MdEmail,
} from "react-icons/md";

const contacts = [
  {
    name: {
      firstname: "Bruce",
      lastname: "Godfrey",
    },
    email: "bgodfrey@uidaho.edu",
    phone: "+1-208-292-1407",
    phone_type: "Work",
    work: "Library Faculty",
    workplace: "University of Idaho, Coeur d'Alene",
  },
];

export const Contacts = () => (
  <RouteItem title="Contacts">
    {contacts.map((contact) => (
      <Flex key={contact.phone}>
        <Flex flexDir="column" alignItems="center">
          <Icon as={MdAccountCircle} boxSize="32px" mb={2}/>
          <Text mb={2} textAlign="center">
            {contact.name.lastname} {contact.name.firstname}
          </Text>
          <Text textAlign="center">{contact.work}</Text>
        </Flex>
        <List spacing={3}>
          <ListItem display="flex" alignItems="center">
            <ListIcon as={MdEmail} color="green.500" boxSize="24px" />
            <Text>{contact.email}</Text>
          </ListItem>
          <ListItem display="flex" alignItems="center">
            <ListIcon as={MdPhone} color="green.500" boxSize="24px" />
            <Text>{contact.phone}</Text>
          </ListItem>
          <ListItem display="flex" alignItems="center">
            <ListIcon as={MdLocationOn} color="green.500" boxSize="24px" />
            <Text>{contact.workplace}</Text>
          </ListItem>
        </List>
      </Flex>
    ))}
  </RouteItem>
);
